import React from 'react';
import { Link } from 'react-router-dom';

const Terms = () => {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 py-20 px-6 lg:px-12">
      <div className="max-w-5xl mx-auto bg-white shadow-xl rounded-3xl border border-slate-200 p-10">
        <h1 className="text-5xl font-light mb-6">Terms and Conditions</h1>
        <p className="text-base text-slate-600 leading-relaxed mb-6">
          Welcome to Intellexa. By accessing or using our website, you agree to these terms and conditions. Please read them carefully before using our services.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">Use of the Website</h2>
        <p className="text-base text-slate-600 leading-relaxed mb-4">
          You may use our website only for lawful purposes and in accordance with these terms. You agree not to use the website in any way that may harm Intellexa, our users, or any third party.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">Intellectual Property</h2>
        <p className="text-base text-slate-600 leading-relaxed mb-4">
          All content on the Intellexa website, including text, graphics, logos, and images, is owned by Intellexa or licensed to it. You may not reproduce, distribute, or use this content without prior written permission.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">Disclaimers</h2>
        <p className="text-base text-slate-600 leading-relaxed mb-4">
          The information provided on our website is for general informational purposes only. Intellexa makes no guarantees regarding the completeness, accuracy, or reliability of the content.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">Limitation of Liability</h2>
        <p className="text-base text-slate-600 leading-relaxed mb-4">
          In no event shall Intellexa be liable for any indirect, incidental, special, or consequential damages arising from your use of the website or reliance on any content.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">Changes to the Terms</h2>
        <p className="text-base text-slate-600 leading-relaxed mb-4">
          Intellexa may revise these terms at any time. Continued use of the website after any changes constitutes acceptance of the updated terms.
        </p>

        <div className="mt-10">
          <Link to="/" className="text-sm font-medium text-blue-600 hover:underline">
            Return to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Terms;
